import { acknowledgeFieldCompletion, patchWorkOrderStatus } from "@/lib/api";

// PM confirms a tech's field completion: acknowledge the close-out, then push the WO to Completed.
// Same function behind the grid's "Confirm" pill and the Ops dashboard's Confirm button.
export async function confirmFieldCompletion(woId) {
  await acknowledgeFieldCompletion(woId);
  const res = await patchWorkOrderStatus(woId, "completed");
  return res.data;
}
